import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input, FormGroup } from 'reactstrap';
import {
  REQUIRED_VIN_LENGTH,
  VIN_HAS_INCORRECT_FORMAT,
  VIN_IS_NOT_LOCATED,
  VIN_HAS_INCORRECT_FORMAT_LENGTH,
} from 'client/site-modules/shared/constants/appraisal/appraisal';
import { FieldError } from 'client/site-modules/shared/components/field-error/field-error';

export function VinTabInput({
  className = '',
  vinInputValue = '',
  onVinChange,
  isError = false,
  isVinValid = true,
  isVinValidLength = true,
  isDecodedVinInvalid = false,
  inputId = 'vin-input',
}) {
  const inputName = 'vin-number';
  return (
    <FormGroup
      className={classnames('styled-input form-group', className, {
        'has-danger': isError,
      })}
      noMargin
    >
      <div className="input-wrapper pos-r">
        <Input
          name={inputName}
          id={inputId}
          type="text"
          className="form-control text-uppercase vin-number"
          value={vinInputValue}
          onChange={onVinChange}
          maxLength={REQUIRED_VIN_LENGTH}
          minLength={REQUIRED_VIN_LENGTH}
          placeholder="Enter VIN"
          aria-required
          required
          aria-describedby="vinError"
          aria-invalid={!!isError}
        />
      </div>
      <FieldError
        id="vinError"
        classes="value-error-text mt-0_5"
        error={
          isError ? (
            <>
              {isVinValidLength && !isVinValid && (
                <div data-testid="vin-incorrect-format-error">{VIN_HAS_INCORRECT_FORMAT}</div>
              )}
              {!isVinValidLength && (
                <div data-testid="vin-incorrect-length-error">{VIN_HAS_INCORRECT_FORMAT_LENGTH}</div>
              )}
              {isDecodedVinInvalid && <div data-testid="vin-not-located-error">{VIN_IS_NOT_LOCATED}</div>}
            </>
          ) : null
        }
        isLiveRegion
      />
    </FormGroup>
  );
}

VinTabInput.propTypes = {
  className: PropTypes.string,
  vinInputValue: PropTypes.string,
  onVinChange: PropTypes.func.isRequired,
  isError: PropTypes.bool,
  isVinValid: PropTypes.bool,
  isVinValidLength: PropTypes.bool,
  isDecodedVinInvalid: PropTypes.bool,
  inputId: PropTypes.string,
};
